import { createSlice } from '@reduxjs/toolkit'

// BE-28. `expenseList` holds the raw Laravel paginator object
// ({current_page, data, per_page, total, ...}) exactly as the API returns
// it under `data` — not unwrapped — so ui/serverPaging's readMeta()/rowsOf()
// can read it directly. See ExpenseApiService.GetExpenseList.
export const ExpenseSlice = createSlice({
    name: 'expense',
    initialState: {
        expenseList: null,
        // BE-31. The Approvals queue — a separate paginator object from
        // expenseList, since the two screens page independently.
        expensePendingList: null,
        // The one global row (App\Models\ExpenseSetting::current()). null
        // until GetExpenseSetting() has run once.
        expenseSetting: null,
        formValue: {
            "credit_category_id": "",
            "credit_sub_category_id": "",
            "date": "",
            "method": "",
            "bank_id": "",
            "amount": "",
            "discount": 0,
            "note": "",
        }
    },
    reducers: {
        onChangeExpenseFormInput: (state, action) => {
            state.formValue[`${action.payload.name}`] = action.payload.value;
        },
        resetExpenseFormValue: (state) => {
            Object.keys(state.formValue).forEach((i) => state.formValue[i] = "");
        },
        setExpenseList: (state, action) => {
            state.expenseList = action.payload
        },
        setExpensePendingList: (state, action) => {
            state.expensePendingList = action.payload
        },
        setExpenseSetting: (state, action) => {
            state.expenseSetting = action.payload
        },
    },
})

export const {
    onChangeExpenseFormInput,
    resetExpenseFormValue,
    setExpenseList,
    setExpensePendingList,
    setExpenseSetting,
} = ExpenseSlice.actions

export default ExpenseSlice.reducer
